export const MEETING_ROOM_FIXED_FIELD = {
  FULL_NAME: 1,
  ORGANIZATION_NAME: 2,
  EMAIL: 3,
  PHONE: 4,
  START_DATE: 5,
  END_DATE: 6,
  START_TIME: 7,
  END_TIME: 8,
  PARTICIPANTS: 9,
  EVENT_NAME: 10,
  EVENT_DESCRIPTION: 11,
} as const

export type MeetingRoomFixedFieldValue =
  (typeof MEETING_ROOM_FIXED_FIELD)[keyof typeof MEETING_ROOM_FIXED_FIELD]

export const MEETING_ROOM_SECTION_VISIBILITY = {
  ALL: 1,
  EVENT: 2,
  COWORKING: 3,
} as const

export type MeetingRoomSectionVisibilityValue =
  (typeof MEETING_ROOM_SECTION_VISIBILITY)[keyof typeof MEETING_ROOM_SECTION_VISIBILITY]

export const MEETING_ROOM_QUESTION_TYPE = {
  SHORT_TEXT: 1,
  LONG_TEXT: 2,
  DATE: 3,
  NUMBER: 4,
  FILE_UPLOAD: 5,
  LINK: 6,
  DROPDOWN: 7,
  MULTIPLE_CHOICE: 8,
  CHECKBOX: 9,
} as const

export type MeetingRoomQuestionTypeValue =
  (typeof MEETING_ROOM_QUESTION_TYPE)[keyof typeof MEETING_ROOM_QUESTION_TYPE]

export interface MeetingRoomFixedFieldRequest {
  id?: string
  fieldName: MeetingRoomFixedFieldValue
  isVisible: boolean
  isRequired: boolean
}

export interface MeetingRoomOptionRequest {
  id?: string
  text: string
  sortOrder: number
}

export interface MeetingRoomQuestionRequest {
  id?: string
  text: string
  description?: string
  type: MeetingRoomQuestionTypeValue
  isRequired: boolean
  sortOrder: number
  options: MeetingRoomOptionRequest[]
}

export interface MeetingRoomSectionRequest {
  id?: string
  name: string
  visible: MeetingRoomSectionVisibilityValue
  sortOrder: number
  questions: MeetingRoomQuestionRequest[]
}

export interface MeetingRoomSettingsSaveData {
  id?: string
  publicSlug?: string
  workingDays: number[]
  openingHour: string
  closingHour: string
  acceptanceCheckboxText?: string
  acceptanceCheckboxIsRequired: boolean
  warningMessage?: string
  meetingSpacesLimit: number
  meetingDaysLimit: number
  meetingMinLeadTime: number
  meetingMaxDuration: number
  meetingAutomaticApproval: boolean
  eventSpacesLimit: number
  eventDaysLimit: number
  eventMinLeadTime: number
  eventInterestDemonstration: boolean
  fixedFields: MeetingRoomFixedFieldRequest[]
  sections: MeetingRoomSectionRequest[]
}

export interface MeetingRoomSettingsSaveRequest {
  data: MeetingRoomSettingsSaveData
}
